import React, { ReactElement } from "react";

interface Props {
  val: number;
  setVal: any;
  valName: string;
  min?: number;
  max?: number;
}

function NumberInput({ val, setVal, valName, min = 0, max = 1e20 }: Props): ReactElement {
  const addVal = (n) => setVal((prevState) => prevState + n);
  const incrementVal = () => addVal(1);
  const decrementVal = () => addVal(-1);
  return (
    <div className="form-inline my-2">
      <label htmlFor="min">{valName}</label>
      <div className="input-group mx-2">
        <div className="input-group-prepend">
          <button className="btn btn-outline-secondary" onClick={decrementVal} disabled={val <= min ? true : false}>
            -
          </button>
        </div>
        <input type="number" name="min" id="min" className="form-control" min={min} max={max} value={val} onChange={(event) => setVal(Number(event.target.value))} />
        <div className="input-group-append">
          <button className={`btn btn-outline-secondary btn-disabled`} onClick={incrementVal} disabled={val >= max ? true : false}>
            +
          </button>
        </div>
      </div>
    </div>
  );
}

export default NumberInput;
